var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gmail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.5642 2.65332L14.0803 8.49385L6.42529 2.65332V2.6549L6.43454 2.66279V10.8411L13.994 16.8079L21.5642 11.0716V2.65332Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.5294 1.23298L21.564 2.65365V11.0719L27.7484 6.32371V3.46343C27.7484 3.46343 26.9977 -0.62178 23.5294 1.23298Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.564 11.0724V21.991H26.304C26.304 21.991 27.6528 21.8521 27.7499 20.3146V6.32422L21.564 11.0724Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.43489 22.0004V10.8419L6.42529 10.834L6.43489 22.0004Z",
    fill: "#C5221F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.42517 2.65469L4.47057 1.24191C1.00224 -0.612849 0.25 3.47078 0.25 3.47078V6.33106L6.42517 10.833V2.65469Z",
    fill: "#C5221F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.42529 2.65527V10.8336L6.43489 10.8415V2.66317L6.42529 2.65527Z",
    fill: "#C5221F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M0.25 6.33398V20.3244C0.345572 21.8635 1.69591 22.0008 1.69591 22.0008H6.43596L6.42517 10.8343L0.25 6.33398Z",
    fill: "#4285F4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.d62b306727792da2f541a5824995696e.svg";
export { ForwardRef as ReactComponent };